import { FormTextHeader } from '@/components/dialogs/Registration/components/FormHeader/FormTextHeader';
import type { NamesSteps } from '@/helpers/auth';
import type { RegistrationConfig, RegistrationTheme } from '../types';

const DARK_SPORTS: RegistrationTheme = {
  bg: '#1F202C',
  color: '#9A9CAC',
  formMarginBottom: '24px',
  colorLinks: '#fff',
  contentPaddingTop: '32px',
  footer: {
    bg: '#323444',
    fontSize: '14px',
    lineHeight: '20px',
    linkGap: '4px',
    fontColor: '#fff',
  },
  steps: {
    bg: '#323444',
    completedLineBg: 'rgba(37, 170, 214,.5)',
    inactive: 'rgba(0,0,0,.2)',
    active: '#25AAD6',
    finish: '#25AAD6',
    color: '#fff',
    inactiveTextColor: '#8E8E93',
  },
  input: {
    bg: '#0E111A',
    borderRadius: '360px',
    colorInput: '#fff',
    color: '#fff',
    height: '48px',
    borderColorFocus: '#383E4F',
    eyeTopPosition: '24px',
    padding: '12px 16px 4px 16px',
    lineHeight: '24px',
    filledPaddingTop: '15.5px',
    inputRightPadding: '16',
  },
  countryTooltip: {
    color: '#8E8E93',
    textColor: '#8E8E93',
    marginLeft: '16px',
    linkHover: 'rgb(37, 170, 214)',
    fontWeight: 400,
  },
  inputLabel: {
    color: '#fff',
    fontSize: '12px',
    lineHeight: '16px',
  },
  textHeader: {
    color: '#FFFFFF',
    marginBottom: '16px',
  },
  regBanner: {
    marginBottom: '16px',
    align: 'center',
    titleFontSize: '14px',
    titleTransform: 'capitalize',
    titleMarginBottom: '3px',
    offerTransform: 'uppercase',
    charactersImgWidth: '149px',
  },
  select: {
    bg: '#0E111A',
    borderRadius: '360px',
    colorInput: '#fff',
    color: '#8E8E93',
    height: '48px',
    borderActive: '#383E4F',
    activeOptionBg: '#1F202C',
    disabledArrowColor: '#8E8E93',
    optionsBorderRadius: '24px',
    optionsBorderActive: '#383E4F',
    disabledOpacity: '0.4',
    bgHover: '#1F202C',
    searchPadding: '4px 24px',
  },
  checkbox: {
    wrapperMargin: 8,
    color: '#fff',
    notActiveBorder: '#8E8E93',
    notActiveBg: '#1F202C',
    activeColor: '#EA5B0C',
    tooltipBorder: '#383E4F',
  },
  error: {
    borderColor: '#FC5555',
  },
};

export const DARK_REG_SPORTS_CONFIG: RegistrationConfig = {
  head: {
    render: (currentRegistrationStep?: NamesSteps) => (
      <FormTextHeader
        addressInfoTitle="auth.registration.addressInfoTitle"
        currentStep={currentRegistrationStep}
        personalDataTitle="auth.registration.personalData"
        size="small"
      />
    ),
  },
  input: {
    withInsideLabel: true,
    showInternalLabelWithValue: false,
  },
  select: {
    withInsideLabel: false,
    withoutLabel: true,
    withStateInsideLabel: true,
  },
  steps: {
    size: 'large',
    withTick: false,
  },
  buttons: {
    regButton: {
      colorMode: { primary: true },
      isRegistrationSticky: true,
      text: 'common:button.joinNow',
    },
    googleRegButton: {
      colorMode: { whiteTransparent: true },
    },
    next: {
      colorMode: { primary: true },
      marginBottom: '16px',
    },
    back: {
      colorMode: { whiteTransparent: true },
      gap: '16px',
    },
  },
  checkbox: {
    termsLinkText: 'auth.registration.form.acceptTermsConditionsShort',
  },
  withPayments: false,
  withNavigationOnFirstStep: false,
  styleScheme: DARK_SPORTS,
};
